// src/mobile/index.ts
import { setNavigationBarConfig } from './navigation';
import {
  setSubNavigationConfig,
  updateSubNavigationItem,
  setSelectedSubNavigationItem,
} from './sub-navigation';
import { setFloatingActionButtonConfig } from './fab';
import { EventManager } from './event-manager';
import { NavigationEventType } from './types';

export const mobileUI = {
  setNavigationBarConfig,
  setSubNavigationConfig,
  setSelectedSubNavigationItem,
  updateSubNavigationItem,
  setFloatingActionButtonConfig,
  registerEvent: (
    eventType: NavigationEventType,
    actionId: string,
    callback: (data?: any) => void
  ) => {
    EventManager.getInstance().registerCallback(eventType, actionId, callback);
  },
};
